// extracted by mini-css-extract-plugin
export var externalLink = "_83-0";
export var internalLinkLabel = "_83-1";